module.exports = __webpack_public_path__ + "static/media/pg-negativo.75b4ad6b.png";